const state = {
  loading: false,
  rules: {
    required: value => !!value || 'Campo obrigatório',
    lenSixOrGreater: value => value && value.length >= 6 || 'Mínimo de 6 caracteres',
    cep: value => value && value.length === 8 || 'CEP inválido',
    zeroOrGreater: value => value >= 0 || 'Valor inválido',
    greaterThanZero: value => value > 0 || 'Valor inválido',
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Formato do e-mail inválido';
    }
  }
}

const getters = {
  loading: state => state.loading,
  rules: state => state.rules
}

const mutations = {
  SET_LOADING: (state, loading) => state.loading = loading
}

export default {
  state,
  getters,
  mutations
}